module.exports = __webpack_public_path__ + "static/img/dongcha.b21ce30.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dongcha.gif
// module id = Dy0d
// module chunks = 1